/** Skip Logic */

import _ from 'lodash';

/**
 * This function validates the skip logic based on the operation
 * @param {*} answer
 * @param {*} Condition
 * @returns boolean
 */
const validateMatch = (answer, Condition) => {
  const {
    operation,
    questionOptionId: ConditionOption,
  } = Condition;

  switch (operation) {
    case 'is': {
      return answer.questionOptionId && answer.questionOptionId === ConditionOption;
    }
    case 'is_selected': {
      return answer.questionOptionIds && _.includes(answer.questionOptionIds, ConditionOption);
    }
    case 'is_not': {
      return answer.questionOptionId && answer.questionOptionId !== ConditionOption;
    }
    case 'is_not_selected': {
      return answer.questionOptionIds && !_.includes(answer.questionOptionIds, ConditionOption);
    }
    default:
      throw new Error('Error validating skip logic.');
  }
};

/**
 * This function builds the skip logic to validates all statements
 * @param {*} answers
 * @param {*} page
 * @returns null | undefined | string
 */
export const buildSkipLogic = (answers, page) => {
  if (_.isEmpty(page.skipLogic)) {
    return null;
  }

  let matched = false;
  let targetPageId;

  const { conditions } = page.skipLogic;

  _.forEach(conditions, (condition) => {
    if (matched) return;

    const { skipConditions } = condition;

    _.forEach(skipConditions, (skipCondition, index) => {
      if (index > 0 && !matched) return;

      const { questionId } = skipCondition;
      const answer = _.find(answers, { questionId });

      if (!answer) return;

      matched = validateMatch(answer, skipCondition);
    });

    if (matched) {
      targetPageId = condition.surveyPageId;
    }
  });

  return targetPageId;
};

/**
 * This function builds the display logic to determine which questions to display
 * @param {*} answers
 * @param {*} pages
 * @returns questionVisibility
 */
export const buildDisplayLogic = (answers, pages) => {
  const questionVisibility = {};

  _.forEach(pages, (page) => {
    if (_.isEmpty(page.displayQuestion)) {
      // No displayQuestion conditions on this page
      return;
    }

    const { conditions } = page.displayQuestion;

    _.forEach(conditions, (condition) => {
      const { displayConditions, questionsList } = condition;

      const conditionMatched = _.every(displayConditions, (displayCondition) => {
        const answer = _.find(answers, { questionId: displayCondition.questionId });
        if (!answer) return false;

        return validateMatch(answer, displayCondition);
      });

      _.forEach(questionsList, (questionId) => {
        questionVisibility[questionId] = questionVisibility[questionId] || conditionMatched;
      });
    });
  });

  return questionVisibility;
};
